import { FILTER_TYPES, PAGE_SIZE_FILTER } from 'constants/filterType';

export const MANIFEST_FILTER_OPTIONS = [
  {
    field: 'manifest_code__icontains',
    label: 'Manifest Code',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'manifest_status',
    label: 'Manifest Status',
    type: FILTER_TYPES.MULTI_SELECT,
    options: [
      { value: 'created', label: 'Created' },
      { value: 'closed', label: 'Closed' },
      { value: 'discarded', label: 'Discarded' },
    ],
  },
  {
    field: 'created_after',
    label: 'Created After',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'created_before',
    label: 'Created Before',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'modified_after',
    label: 'Modified After',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'modified_before',
    label: 'Modified Before',
    type: FILTER_TYPES.DATE,
  },
  { ...PAGE_SIZE_FILTER },
];
